import { Component, OnInit } from '@angular/core';

import { ISkfConfigEntity } from '@shared-interfaces/api';

import { Equipment } from '../../scripts/equipment';
import { ProductionEquipment } from '../../scripts/productionEquipment';
import { DatahubService } from '../../services/datahub.service';

@Component({
  selector: 'equipment',
  templateUrl: './equipment.component.html',
  styleUrl: './equipment.component.css',
  standalone: false,
})
export class EquipmentComponent implements OnInit {
  public equipmentProductionButtons: ISkfConfigEntity[] = [];
  public shouldShowEquipmentSkf = false;
  public readonly timeSheet = this.datahub.timesheet;

  constructor(private readonly datahub: DatahubService) {}

  public ngOnInit(): void {
    this.datahub.costCenter.setCostCenterValueWithString(this.datahub.extDocument.Costcenter1, true);
    this.equipmentProductionButtons = this.datahub.contract.makeEmptyProduction().equipment;
    this.shouldShowEquipmentSkf = this.equipmentProductionButtons.length > 0;
  }

  public bulkEntry(): void {
    this.timeSheet.bulkEntryEquipment$().subscribe((value) => {
      if (value && value !== '') {
        this.timeSheet.currentEquipmentCrew.forEach((row: Equipment) => {
          if (!row.value.disabled) row.setValue(value);
        });
        this.timeSheet.currentEquipmentProduction.forEach((row: ProductionEquipment) => {
          if (!row.value.disabled) row.setValue(value);
        });
      }
    });
  }

  public handleEquipmentDelete(equipment: ProductionEquipment): void {
    this.timeSheet.flagForDelete(equipment);
    equipment.deleteSelf(this.timeSheet.currentEquipmentProduction);
  }

  public addEquipment(skf: ISkfConfigEntity): void {
    let highest = 0;
    this.timeSheet.currentEquipmentProduction
      .filter((x) => skf.SKF === x.skf)
      .forEach((element) => {
        if (element.position > highest) {
          highest = element.position;
        }
      });

    const newSkf = new ProductionEquipment(skf);
    newSkf.activate(highest + 1);
    this.timeSheet.currentEquipmentProduction.push(newSkf);
  }
}
